export interface ContentMenuPosition {
  currentTarget: Pick<ClientRect, "top" | "bottom">;
  offsetParent: Pick<ClientRect, "top" | "bottom">;
}

export enum ActionType {
  RENAME = "Rename",
  DELETE = "Delete",
  ADD_FOLDER = "Add folder",
}
